import React, { useState, useEffect } from "react";
import styles from "../CommonStyles/commonformstyles.module.scss";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import {
  useEditSocialDetails,
  useUpdateSocialDetails,
} from "../../../../hooks/partnerHook/usePartner";

const SocialForm = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.partner.user);
  let partnerId = null;
  if (userData) {
    partnerId = userData.partner.id;
  }

  const [formData, setFormData] = useState({
    facebook: "",
    instagram: "",
    linkedin: "",
    youtube: "",
    website: "",
  });

  useEffect(() => {
    if (userData && userData?.partner?.socialDetails) {
      setFormData({
        facebook: userData.partner.socialDetails.facebook_link || "",
        instagram: userData.partner.socialDetails.instagram_link || "",
        linkedin: userData.partner.socialDetails.linkedin_link || "",
        youtube: userData.partner.socialDetails.youtube_link || "",
        website: userData.partner.socialDetails.website_link || "",
      });
    }
  }, [userData]);

  const {
    mutate: createUserSocialDetails,
    isSuccess: updateSuccess,
    isPending: updatePending,
    isError: updateError,
  } = useUpdateSocialDetails();

  const {
    mutate: editSocialDetails,
    isSuccess: editSuccess,
    isPending: editPending,
    isError: editError,
  } = useEditSocialDetails();

  useEffect(() => {
    if (updateSuccess || editSuccess) {
      toast.success("Social details saved successfully!");
      navigate("/dashboard/social");
    }
  }, [updateSuccess, editSuccess]);

  useEffect(() => {
    if (updateError || editError) {
      toast.error("Failed to update social details. Please try again.");
    }
  }, [updateError, editError]);

  const handleFormSubmission = (e) => {
    e.preventDefault();
    if (userData.partner.socialDetails) {
      editSocialDetails({ partnerId, socialData: formData });
    } else {
      createUserSocialDetails({ partnerId, socialData: formData });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <div className={styles.dashboardFormContainerWrapper}>
      <div className={styles.dashboardFormContainer}>
        <form className={styles.FormContainer} onSubmit={handleFormSubmission}>
          <h2 className={styles.dashboardFormContinerHeading}>
            Social Details
          </h2>
          <p className={styles.noEquipmentDescription}>
            Add links to your professional social media accounts.
          </p>
          <hr className={styles.kycTitleDivider} />
          <div className={styles.dashboardFormInputLabelField}>
            <label className={styles.dashFormContainerLabel} htmlFor="facebook">
              Facebook
            </label>

            <div className={styles.inputContainer}>
              <input
                id="facebook"
                name="facebook"
                type="url"
                value={formData.facebook}
                onChange={handleInputChange}
                placeholder="https://example.fb.com"
              />
            </div>
          </div>

          <div className={styles.dashboardFormInputLabelField}>
            <label
              className={styles.dashFormContainerLabel}
              htmlFor="instagram"
            >
              Instagram
            </label>
            <div className={styles.inputContainer}>
              <input
                id="instagram"
                name="instagram"
                type="url"
                value={formData.instagram}
                onChange={handleInputChange}
                placeholder="https://example.instagram.com"
              />
            </div>
          </div>

          <div className={styles.dashboardFormInputLabelField}>
            <label className={styles.dashFormContainerLabel} htmlFor="linkedin">
              Linkedin
            </label>
            <div className={styles.inputContainer}>
              <input
                id="linkedin"
                name="linkedin"
                type="url"
                value={formData.linkedin}
                onChange={handleInputChange}
                placeholder="https://example.linkedin.com"
              />
            </div>
          </div>

          <div className={styles.dashboardFormInputLabelField}>
            <label className={styles.dashFormContainerLabel} htmlFor="youtube">
              Youtube
            </label>
            <div className={styles.inputContainer}>
              <input
                id="youtube"
                name="youtube"
                type="url"
                value={formData.youtube}
                onChange={handleInputChange}
                placeholder="https://example.youtube.com"
              />
            </div>
          </div>

          <div className={styles.dashboardFormInputLabelField}>
            <label className={styles.dashFormContainerLabel} htmlFor="website">
              Website
            </label>
            <div className={styles.inputContainer}>
              <input
                id="website"
                name="website"
                type="url"
                value={formData.website}
                onChange={handleInputChange}
                placeholder="https://example.web.com"
              />
            </div>
          </div>

          <div className={styles.btnContainer}>
            <button
              type="submit"
              className={styles.dashboardFormSaveButtonDown}
              disabled={editPending || updatePending}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SocialForm;
